module.exports = __webpack_public_path__ + "img/CNC加工中心2.7d82a513.jpg";